<template>
  <div class="exchange-wrapper">
   <tiga-notice />
    <div :class="['exchange-container', isShowDetail ? 'next' : '']">
      <div class="content-item">
        <exchange-page ref="exchange" />
      </div>
      <div class="content-item">
        <take-order v-if="isShowDetail" :id="orderId" />
      </div>
    </div>

 <md-dialog
      :title="this.$t('common.lossWarnTitle')"
      :closable="false"
      v-model="lossDialog.open"
      :btns="lossDialog.btns"
    >
        <span style="font-weight:bold;color:red;">
        <p
        v-html="$t('common.warnText1')"
        >
        </p>
        </span> 
        <span style="color:red;">
        {{$t('common.warnText2')}}
        </span>
        {{$t('common.warnText3')}}
        {{$t('common.warnText4')}}
        {{$t('common.warnText42')}}
        {{$t('common.adjustFeeText')}}
        <span style="font-weight:bold;color:red;">
        {{$t('common.warnText5')}}
        </span>
        <p style="margin-top: 5px;"></p>
       <md-agree
      v-model="agreeConf.checked"
      :disabled="agreeConf.disabled"
      :size="agreeConf.size"
      icon-type="square"
      @change="onAgreeChange(agreeConf.checked, $event)"
    >
         {{$t('common.warnText7')}}
      <a style="text-decoration: none;" href="javascript:void(0)" @click="showAgreement()" >《{{ $t('global.login.agreementName') }}》</a>
    </md-agree>
   
    </md-dialog>

  </div>
</template>

<script>
import {Dialog, Agree } from 'mand-mobile';
import tigaNotice from '@/components/tiga-notice.vue';
import ExchangePage from './exchange.vue';
import takeOrder from './take-order/take-order.vue';
import { mapState } from 'vuex';
export default {
  components: {
    tigaNotice,
    ExchangePage,
    takeOrder,
    [Dialog.name]: Dialog,
    [Agree.name]: Agree,
  },
  data() {
    return {
      isExchangeInited: false,
      isNoviceGuideShow: false,
      agreeConf: {
        checked: false,
        name: 'agreeRisk',
        size: 'md',
        disabled: false,
        introduction: '风险须知同意',
      },
      lossDialog: {
        open: true,
        btns: [
          {
            text: this.$t('common.cancel'),
          },
          {
            text: this.$t('common.confirm'),
            warning: true,
            handler: this.onLossConfirm,
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(['userInfo', 'isLogin']),
    isShowDetail() {
      return this.$route.path === '/exchange/takeOrder';
    },
    orderId() {
      return this.$route.query.id || '';
    },
  },
  watch: {
    $route(newRoute) {
      if (newRoute.name === 'index') {
        this.initExchange();
        this.$emit('check-guide');
      }
    },
  },
  mounted() {
    this.initExchange();
    this.$emit('check-guide');
  },
  methods: {
    initExchange() {
      if (
        this.$route.name === 'index' &&
        !this.isExchangeInited &&
        this.$refs.exchange
      ) {
        this.isExchangeInited = true;
        this.$refs.exchange.init();
      }
    },
    onAgreeChange(checked) { //下单前同意风险及用户条例
      this.agreeConf.checked = checked;
    },
    onLossConfirm() { //弹窗确认按钮
      if(this.agreeConf.checked == true){
        this.lossDialog.open = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.exchange-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.exchange-container {
  display: flex;
  width: 200vw;
  height: 100%;
  transform: translate3d(0, 0, 0);
  will-change: transform;

  &.next {
    transform: translate3d(-50%, 0, 0);
  }
}

.content-item {
  position: relative;
  width: 100vw;
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
